const arrowsBetweenStrings = {
    fallback: '[BRAK NAZWY]'
};

export default arrowsBetweenStrings;